import React from "react";
import vandaLogo from "../assets/images/vandaLogo.png";
import { cn } from "./Utils";

const BrandComponent = ({ width, height, className }) => {
  return (
    <div
      className={cn(
        "flex flex-row md:flex-col gap-2 items-center justify-end",
        className
      )}
    >
      <img src="/images/vandabrand.png" width={width} height={height} alt="" />
      
    </div>
  );
};

export default BrandComponent;
